(ns bp-clients.tv-app.analytics.events
  "Namespace for all analytics events"
  (:require
   [bp-clients.tv-app.api.graphql.analytics :as analytics]
   [re-frame.core
    :as rf
    :refer [path reg-event-db reg-event-fx]]
   [re-graph.core :as re-graph]))

(def ^:private analytics-path ::analytics)

(def ^:private analytics-interceptors
  "Checks spec and selects analytics path interceptor"
  [(path analytics-path)])

(defn- set-session-id-ev
  [db [_ session-id]]
  (assoc db :session-id session-id))

(defn event-callback
  "re-graph callback is required;
  returns a empty effect map"
  [_ _]
  {})

(defn- send-screen-requested-ev
  [{:keys [db]} [_ params]]
  {:db db
   :dispatch [::re-graph/mutate {:instance-id :auth
                                 :id          (random-uuid)
                                 :query       analytics/screen-requested-query
                                 :callback    [::event-callback]
                                 :variables   (cond-> {:input {:view (:view params)}}
                                                (:item-id params)
                                                (assoc-in [:input :item_id] (:item-id params)))}]})

(reg-event-fx ::event-callback analytics-interceptors event-callback)
(reg-event-fx ::screen-requested analytics-interceptors send-screen-requested-ev)
(reg-event-db ::set-session-id analytics-interceptors set-session-id-ev)
